<script>
  import { layoutMethods  } from "@/state/helpers";
  /**
   * Bills Payment component
   */
  export default {
    page: {
      title: "Mobile Legend Diamond"
    },
    data() {
      return {
        title: "Mobile Legend Diamond",
      };
    },
    methods: {
      ...layoutMethods
    },
    mounted(){
      this.changeTitle({title: 'Mobile Legend Diamond'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Mobile Legend Diamond', to: { name: 'ML Diamond'} }
        ]
      });
    }
  }
    
</script>

<template>
  <div>
      This is Mobile Legend Diamond New Page
  </div>
</template>